<template>
  <div class="link-text"
       @click="openTo">
    <span>{{getUrl || '-'}}</span>
  </div>
</template>

<script>
export default {
  props: {
    bind: [Function, String],
    target: {
      default: '_blank'
    }
  },
  computed: {
    getUrl () {
      if (typeof this.bind == 'function') return this.bind(this.$attrs)
      if ('value' in this.$attrs) return this.$attrs.value
    }
  },
  methods: {
    openTo () {
      if (this.getUrl) {
        window.open(this.getUrl, this.target)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.link-text {
  color: #3da1ff;
  cursor: pointer;
}
</style>